
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.853 11.146l-5.279-5.28.331-.33a.5.5 0 000-.708l-.178-.179c.305-.156 1.084-.196 2.12.18a.503.503 0 00.664-.39c.013-.078.29-1.92-1.099-3.31C7.024-.259 5.18.02 5.103.03a.5.5 0 00-.39.665c.398 1.095.434 1.938.312 2.252l-.174-.174a.498.498 0 00-.707 0l-1.37 1.37a.5.5 0 000 .707l.174.174c-.315.123-1.157.086-2.252-.312a.503.503 0 00-.665.39c-.013.078-.29 1.921 1.1 3.31.977.978 2.179 1.13 2.833 1.13.275 0 .452-.027.475-.031a.5.5 0 00.39-.665c-.375-1.035-.335-1.815-.18-2.12l.18.18a.5.5 0 00.707 0l.331-.332 5.28 5.28a.499.499 0 00.706 0 .5.5 0 000-.707z"}})])
          )
        }
      }
    